import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Chargement...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && (!user || !user.is_staff)) {
    return <Navigate to="/worker" replace />;
  }

  // Redirection automatique selon le type d'utilisateur
  if (!requireAdmin && user && user.is_staff && window.location.pathname.startsWith('/worker')) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default ProtectedRoute;
